//
export function observeObject<T>(obj: T, props: (number | string)[], callback: (instance: T, propName?: string | number, previous?: any,) => void) {
  if (typeof obj != 'object' || obj == null) {
    console.error('only object can be observe');
    return;
  }
  for (let prop of props) {
    let privateProp = `__${prop}`;
    Object.defineProperty(obj, privateProp, {
      writable: true,
      enumerable: false,
      configurable: true,
      value: obj[prop],
    })
    Object.defineProperty(obj, prop, {
      enumerable: true,
      get() {
        return this[privateProp];
      },
      set(newValue: any) {
        let previous = this[privateProp];
        this[privateProp] = newValue;
        if (previous != newValue) {
          callback?.(this, prop, previous);
        }
      }
    })
  }

}
